import { config } from "../../config";
import session from "./session-store";

async function handleZendeskRoute(routeInfo) {
    var loggedIn = !!session.state.user;
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    var zendeskReturn = params.return_to ? params.return_to : routeInfo.query.return_to;

    if(loggedIn) {
        goToZenDesk(session.state.user.userId, zendeskReturn);
    }
    else {
        sendToRomeLoginAndComeBackHere(zendeskReturn);
    }
}

async function goToZenDesk(userId, zendeskReturn) {
    var result = await romeApi.get(`user/${userId}/zendesk/sso`);
    var sso = result.sso;
    if(zendeskReturn) {
        window.location.href = `${sso}&return_to=${encodeURI(zendeskReturn)}`;
    }
    else {
        let windowReference = window.open();
        let form = windowReference.document.createElement('form');
        form.setAttribute('method', 'post');
        form.setAttribute('type', 'hidden');
        form.setAttribute('action', result.sso);

        let input = windowReference.document.createElement('input');
        input.name = 'jwt';
        input.type = 'hidden';
        input.value = result.jwtInput;
        form.appendChild(input);

        windowReference.document.body.appendChild(form);

        form.submit();

        windowReference.document.body.removeChild(form);
    }
}

function sendToRomeLoginAndComeBackHere(zendeskReturn) {
    var returnUrl = `${config.romeUi}#/zendesk/sso`;

    if(zendeskReturn) {
        returnUrl = `${returnUrl}?return_to=${zendeskReturn}`;
    }

    window.location.href = `${config.romeUi}/#/login?returnUrl=${encodeURIComponent(returnUrl)}`;
}

export default { handleZendeskRoute, goToZenDesk }



// WEBPACK FOOTER //
// ./src/framework/utils/zendesk-sso.js